import Pepperoni from "../assets/pepperoni.jpg";
import Margherita from "../assets/margherita.jpg";
import LucasSpecial from "../assets/lucasspecial.jpg";
import Vegan from "../assets/vegan.jpg";
import Pineapple from "../assets/pineapple.jpg";
import Expensive from "../assets/expensive.jpg";

export const MenuList = [
  {
    name: "Pepperoni Pizza",
    image: Pepperoni,
    price: 15.99
  },
  {
    name: "Margherita Pizza",
    image: Margherita,
    price: 11.99
  },
  {
    name: "Lucas Special Pizza",
    image: LucasSpecial,
    price: 256.53
  },
  {
    name: "Vegan Pizza",
    image: Vegan,
    price: 17.99
  },
  {
    name: "Pineapple Pizza",
    image: Pineapple,
    price: 4.99
  },
  {
    name: "Very Expensive Pizza",
    image: Expensive,
    price: 1997.99
  }
];
